import { SegmentProvider } from './segment';

const ANONYMOUS_ID_STORAGE_KEY = '__extern_anonymous_id';

/** In-session id when localStorage throws or cannot persist (private mode, disabled storage, quota). */
let memoryCachedAnonymousId: string | undefined;

function createFallbackAnonymousId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function getAnonymousCorrelationId() {
  const segmentProvider = new SegmentProvider();

  const segmentAnonymousId = segmentProvider.anonymousId();
  if (segmentAnonymousId) {
    return segmentAnonymousId;
  }

  if (typeof window === 'undefined') {
    return createFallbackAnonymousId();
  }

  try {
    const storedAnonymousId = window.localStorage.getItem(ANONYMOUS_ID_STORAGE_KEY);
    if (storedAnonymousId) {
      return storedAnonymousId;
    }
  } catch {
    // localStorage can throw when disabled, in restricted contexts, or quota exceeded
  }

  if (memoryCachedAnonymousId) {
    return memoryCachedAnonymousId;
  }

  const fallbackAnonymousId = createFallbackAnonymousId();
  memoryCachedAnonymousId = fallbackAnonymousId;

  try {
    window.localStorage.setItem(ANONYMOUS_ID_STORAGE_KEY, fallbackAnonymousId);
  } catch {
    // Best-effort persist; memoryCachedAnonymousId keeps this browsing session stable
  }

  return fallbackAnonymousId;
}
